module.exports = __webpack_public_path__ + "static/media/pocket-drop.d19b0496.mp3";